
import React, { useState, useEffect,  } from 'react';
import { StyleSheet, Text, View, Image, TouchableOpacity, TextInput,} from 'react-native';
import logo from './../assets/logo-psihomaestru-3.png'; 
import { Ionicons } from '@expo/vector-icons';
import * as Crypto from 'expo-crypto';

export default function Signup1({navigation, route}) {

    const { tokenKey } = route.params;
    const { email } = route.params;
    const { name } = route.params;
    const { Diagnostic } = route.params;
    const { PUN_utilizatorID } = route.params;
    const { age } = route.params;
    const { ocupation } = route.params;
    const { mediu } = route.params;
    const { sex } = route.params;
    const { sectiune } = route.params;



    const [shouldShowMandatoryPreNume, setShouldShowMandatoryPreNume] = useState(false);
    const [shouldShowMandatoryNume, setShouldShowMandatoryNume] = useState(false);
    const [shouldShowMandatoryPass1, setShouldShowMandatoryPass1] = useState(false);
    const [shouldShowMandatoryPass2, setShouldShowMandatoryPass2] = useState(false);

    const [isLoading, setLoading] = useState(true);

    //Post search method to find email utilizatori
    let [utilizatorID, setutilizatorID] = useState(PUN_utilizatorID);
    let [U_status, setU_Status] = useState('');
    let [preNume, setpreNume] = useState('');
    let [Nume, setNume] = useState('');
    let [Pass1, setPass1] = useState('');
    let [Pass2, setPass2] = useState('');
    let [length, setLength] = useState();

    const UpdateUtilizator = async  () => {
      try {
        const response = await fetch('https://rupertapi.azurewebsites.net/api/utilizator/'+utilizatorID, {
          method:'PUT',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+tokenKey
          },
          body: JSON.stringify(
            {
              "PreNume" : preNume,
              "Nume" : Nume,
              "Email": email,
              "status":2,
              "Varsta":age,
              "Ocupatia": ocupation,
              "Mediu": mediu,
              "Sex": sex,
              "DataCreearii": currentDate,
              "Password": Pass1
          }
          )
        }
        )
        const json = await response.json();
        console.log();
        setLoading(true);
        generateKeys();
        navigation.replace('Diagnostic',
          {
            email:email,
            name:name,
            preNume:preNume,
            Nume:Nume,
            tokenKey:tokenKey, 
            Diagnostic:Diagnostic, 
            PUN_utilizatorID:json, 
            age:age, 
            mediu:mediu, 
            ocupation:ocupation, 
            sex:sex,
            currentDate: currentDate,
            sectiune: sectiune,
          });
      } catch (error) {
        console.error(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    const generateKeys = async () => {
      setLoading(true);
      try {
          const appToken = await Crypto.digestStringAsync(
            Crypto.CryptoDigestAlgorithm.SHA256,
            email
          );
          const appSecret = await Crypto.digestStringAsync(
            Crypto.CryptoDigestAlgorithm.SHA256,
            Pass1
          );
          return new Promise(resolve => {
              if (appToken !== null || appSecret !== null) {
                resolve()
                console.log("Keys Generated")
                AuthorizeUtilizator(appToken,appSecret)
              }
            })

      } catch (error) {
        console.error(error);
        setError('Error 2033!');
      } finally {
        // setLoading(false);
      }
    }
    const AuthorizeUtilizator = async  (appToken,appSecret) => {
      try {
        const response = await fetch('https://rupertapi.azurewebsites.net/api/authorize', {
          method:'PUT',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+tokenKey
          },
          body: JSON.stringify(
            {
              "name": utilizatorID,
              "appToken": appToken,
              "appSecret": "a95bc16631ae2b6fadb455ee018da0adc2703e56d89e3eed074ce56d2f7b1b6a",
              "TokenExpiration": expirationDate
          }
          )
        }
        )
        const json = await response.json();
        console.log();
        setLoading(true);

      } catch (error) {
        console.error(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    const logout = () => {
        setLoggedinStatus(false);
        setUserData(null);
        setImageLoadStatus(false);
        setEmail('');
        setisValidEmail(false);
    }

    let [isValidPass, setisValidPass] = useState(false);
    const validatePass = (enteredpassword) => {
      const expression = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
      return expression.test(String(enteredpassword));
    //  setisValidPass([
    //     '^.{8,}$', // min 8 chars
    //     '(?=.*\\d)', // number required
    //     '(?=.*[A-Z])', // uppercase letter
    //     '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})', //strongPassword 
    //     '((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))' //mediumPassword 
    //   ]);
    }



    const checkTextInput = () => {
        if (!preNume.trim()) {
          setShouldShowMandatoryPreNume(true);
          return;
        } 
        setShouldShowMandatoryPreNume(false);
        if (!Nume.trim()) {
          setShouldShowMandatoryNume(true);
          return;
        }
        setShouldShowMandatoryNume(false);
        if (!Pass1.trim()) {
          setShouldShowMandatoryPass1(true);
          return;
        }
        
        setShouldShowMandatoryPass1(false);
        if (!Pass2.trim()) {
          setShouldShowMandatoryPass2(true);
          return;
        }
        if(!(Pass1===Pass2)) {
          setShouldShowMandatoryPass2(true);
          return;
        }
        if (!isValidPass){
          return;
        }
        setShouldShowMandatoryPass2(false);
        UpdateUtilizator();

    }




    // console.log('U_status: '+ U_status)
    // console.log('utilizatorID:'+utilizatorID);
    // console.log('token:'+tokenKey);
    // console.log('preNume:'+preNume);
    // console.log('length:'+length);
    // console.log('email:'+email);

    // console.log('Nume:'+Nume);
    // console.log('Diagnostic: '+ Diagnostic);
    // console.log('shouldShowMandatoryPreNume: '+ shouldShowMandatoryPreNume);
    // console.log('shouldShowMandatoryNume: '+ shouldShowMandatoryNume);
    // console.log('shouldShowMandatoryPass1: '+ shouldShowMandatoryPass1);
    // console.log('shouldShowMandatoryPass2: '+ shouldShowMandatoryPass2);
    // console.log('isValidPass:'+isValidPass);
    // console.log('pass1:'+Pass1);
    // console.log('pass2:'+Pass2);
    // console.log(Pass1===Pass2);
    // console.log('age: '+age)
    // console.log('mediu: '+mediu);
    // console.log('ocupation: '+ocupation);
    // console.log('sex: '+sex );

    // console.log('PUNutilizatorID:'+PUN_utilizatorID);

      //Get current Date, set expiration date
  const [currentDate, setCurrentDate] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  console.log('Current Date:'+currentDate);
    useEffect(() => {
      var date = new Date().getDate(); //Current Date
      var month = new Date().getMonth() + 1; //Current Month
      var year = new Date().getFullYear(); //Current Year
      var hours = new Date().getHours(); //Current Hours
      var min = new Date().getMinutes(); //Current Minutes
      var sec = new Date().getSeconds(); //Current Seconds
      setCurrentDate(
        year + '-' + month + '-' + date + ' ' + hours + ':' + min + ':' + sec
      );
      setExpirationDate(
        year + 1 + '-' + month + '-' + date + ' ' + hours + ':' + min + ':' + sec
      );

      setShouldShowMandatoryPreNume(false);
      setShouldShowMandatoryNume(false);
      setShouldShowMandatoryPass1(false);
      setShouldShowMandatoryPass2(false);
     }, []);

  return (
    <View style={styles.container}>
      <Image style={styles.logo} source={logo} />
      <Text style={styles.h1}>{email}</Text>
      <Text style={styles.MainText}>Hai să iți creăm un cont nou!</Text>
      <TextInput 
      name='prenume'
      style={styles.inputPrenume}
      placeholder='Prenumele aici'
      // value={name}
      onChangeText={
          (val) => {setpreNume(val)}
      }
      />
      {shouldShowMandatoryPreNume ? (
      <Text style={styles.inputMandoPrenume}>Te rog să-ți completezi Prenumele!</Text>
      ) : null
      }
      <TextInput 
      name='nume'
      style={styles.inputNume}
      placeholder='Numele aici'
      // value={name}
      onChangeText={
          (val) => {setNume(val)}
      }
      />
      {shouldShowMandatoryNume ? (
      <Text style={styles.inputMandoNume}>Te rog să-ți completezi Numele!</Text>
      ) : null
      }
      
      <TextInput 
      name='parola'
      style={styles.inputPassword1}
      placeholder='parola aici'
      secureTextEntry={true}
      // pattern={[
      //   '^.{8,}$', // min 8 chars
      //   '(?=.*\\d)', // number required
      //   '(?=.*[A-Z])', // uppercase letter
      // ]}
      onChangeText={
        (val) => {setPass1(val); setisValidPass(validatePass(val))}
      }
      />
      {shouldShowMandatoryPass1 ? (
      <Text style={styles.inputMandoPassword1}>Te rog să introduci o parola!</Text>
      ) : null
      }

      <TextInput 
      name='parolarepeat'
      style={styles.inputPassword2}
      placeholder='repeta parola'
      secureTextEntry={true}
      onChangeText={
        (val) => {setPass2(val)}
      }
      />
      {shouldShowMandatoryPass2 ? (
      <Text style={styles.inputMandoPassword2}>Te rog să repeți parola introdusă anterior!</Text>
      ) : null
      }
      {!isValidPass ? (
      <Text style={styles.inputStrongPassword1}>Parola aleasă trebuie să îndeplinească condițiile de siguranță:{"\n"}
      - să conțina cel puțin 8 caractere{"\n"}
      - cel puțin una cu literă mare{"\n"}
      - una cu literă mică{"\n"}
      - una sa fie cifră.</Text>
      ) : 
      null
      }
      <TouchableOpacity
      style={styles.buttonPlay}
      onPress={() => {
          checkTextInput();
          }}
      >
      <Ionicons name="md-enter" size={24} color="#628914" />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#e9ebee',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginBtn: {
    backgroundColor: '#EFEB88',
    position: 'absolute',
    top: 260,
    alignSelf: 'center',
    width: 50,
    height: 50,
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  logoutBtn: {
    backgroundColor: '#EFEB88',
    position: "absolute",
    top: 400,
    alignSelf: 'center',
    width: 50,
    height: 50,
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  logo: {
    alignSelf: 'flex-start',
    left: 20,
    width: 200, 
    height: 50,
    position: 'absolute',
    top: 10,
  },
  h1: {
    fontSize: 16,
    alignContent: "center",
    fontWeight: 'bold',
    position: 'absolute',
    top: 70,
    color:"#628914",
  },
  MainText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: "#3E473A",
    flexShrink: 1,
    position: 'absolute',
    top:90,
  },

  MainText2: {
    fontSize: 14,
    fontWeight: 'bold',
    color: "#3E473A",
    flexShrink: 1,
    position:"absolute",
    top:340,
  },
  inputPrenume: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    position: 'absolute',
    top:110,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 200,
    borderRadius:25,
  },
  inputMandoPrenume: {
    position: 'absolute',
    top:160,
    color: 'red'
  },
  inputNume: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    position: 'absolute',
    top:170,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 200,
    borderRadius:25,
  },
  inputMandoNume: {
    position: 'absolute',
    top:220,
    color: 'red'
  },
  inputPassword1: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    position: 'absolute',
    top:230,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 200,
    borderRadius:25,
  },
  inputMandoPassword1: {
    position: 'absolute',
    top:280,
    color: 'red'
  },
  inputStrongPassword1: {
    color: '#628914',
    position: 'absolute',
    right:20,
    top:350,
    padding:20,
  },
  inputPassword2: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    position: 'absolute',
    top:290,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 200,
    borderRadius:25,
  },
  inputMandoPassword2: {
    position: 'absolute',
    top:340,
    color: 'red'
  },
  buttonPlay: {
    position: 'absolute',
    top:470,
    alignSelf: 'center',
    width: 50,
    height: 50,
    backgroundColor: '#EFEB88',
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  form: {
    flex: 1,
    justifyContent: 'space-between',
  },
});